import common from "./common.json";
import sys from "./sys.json";
import pos from "./pos.json";

export default {
	...common,
	...sys,
	...pos,
};
